<div class="db-pricing-page-checkout">
  <div class="db-pricing-page-checkout__payment">
    <div class="one-month-free-checkout-demo">
      @if (!!hasBackBtn) {
        <div class="back-wrap" (click)="onBack.emit()">
          <i class="db-icon db-icon-ds-arrow-sharp"></i>
          <span>Back</span>
        </div>
      }
      <h2 class="mb24">Upgrade to {{chosenPlan?.title}} plan</h2>

      <div class="db-checkout__plan-cycle mb32" *ngIf="!!monthlySubscription?.id && !!annuallySubscription?.id">
        <div class="db-checkout__change-plan" [ngClass]="{'checked': chosenPlan?.periodNumber === 12}"
             (click)="changePlan(12)" >
          <div>
            <input class="ds-radio-black" type="radio" id="yearly" name="periodSwitch"
                   value="12"  [checked]="chosenPlan?.periodNumber === 12">
            <label for="yearly" class="big">
              <p class="plan-info">
                Annual<strong class="db-save-promote ml8" [innerHTML]="'-50%'"></strong>
              </p>
            </label>
          </div>
          <p class="ml24 mt2 bright">${{annuallySubscription?.price / 12 | DbNumberFormatPipe: 'floor'}}/month</p>
        </div>

        <div class="db-checkout__change-plan" [ngClass]="{'checked': chosenPlan?.periodNumber === 1}"
             (click)="changePlan(1)">
          <div>
            <input class="ds-radio-black" type="radio" id="monthly" name="periodSwitch"
                   value="1" [checked]="chosenPlan?.periodNumber === 1">
            <label for="monthly" class="big">
              <p class="plan-info">
                Monthly
              </p>
            </label>
          </div>
          <p class="ml24 mt2 bright">${{monthlySubscription?.price | DbNumberFormatPipe: 'floor'}}/month</p>
        </div>
      </div>

      <div class="one-month-free-plans__payment-wrap">
          <db-payment-info (onClose)="closeDialog($event)"
                           (onLoading)="loading = $event"
                           (paymentIsPaypal)="handlePaymentIsPaypal($event)"
                           [chosenPlan]="chosenPlan?.price"
                           [coupon]="coupon"
                           [demoUser]="demoUser"
                           [currentSubscription]="userSubscription"
                           [feature]="isPaid? 'ssh': null"
                           [invited]="isInvited"
                           [isPaypalInvalidCode]="payPalInvalidCoupons.includes(couponCodeInput?.value)"
                           [newPrice]="newPrice"
                           [subscription]="chosenPlan"
                           [user]="user"
                           [forDemo]="true"></db-payment-info>

        <div class="one-month-free-plans__payment-due-wrap-container">
          <div class="one-month-free-plans__payment-due-wrap">
            <div (click)="couponSectionToggled = true"
                 *ngIf="!couponSectionToggled" class="db-one-month-free-plans__coupon-link">
              <span>Have a promo code?</span>
            </div>
            <div *ngIf="couponSectionToggled" class="coupon-input-wrap">
                          <span
                            *ngIf="couponCodeInput?.invalid || (payPalInvalidCoupons.includes(couponCodeInput?.value) && !!isPaypal)"
                            [innerHTML]="((payPalInvalidCoupons.includes(couponCodeInput?.value) && !!isPaypal) ? 'text_invalidPaypalCouponCodeError' : 'text_checkout_coupon_server_error') | dbText"
                            class="ds-input-error-msg">
                                    </span>
              <div *ngIf="!coupon || !coupon?.couponCode || coupon?.couponCode === '1wf'"
                   class="db-one-month-free-plans__coupon-wrap">
                <div [ngClass]="{'with-error': (payPalInvalidCoupons.includes(couponCodeInput?.value) && !!isPaypal)}"
                     class="ds-input-wrap">
                  <div class="button-input-wrapper">
                    <input [formControl]="couponCodeInput"
                           [ngClass]="{'error': couponCodeInput?.invalid || (payPalInvalidCoupons.includes(couponCodeInput?.value) && !!isPaypal)}"
                           class="ds-input" placeholder="Coupon code" type="text">
                    <button (click)="applyCoupon()"
                            [ngClass]="{'ds-btn-disabled': (couponLoading || !couponCodeInput?.value || !!isPaypal)}"
                            class="ds-btn ds-btn-xs">
                      <span *ngIf="!couponLoading">Apply</span>
                      <db-loading-circular-spinner *ngIf="couponLoading"
                                                   color="dark"></db-loading-circular-spinner>
                    </button>
                  </div>

                  <i (click)="deleteCoupon(false)" *ngIf="couponCodeInput?.value"
                     class="db-icon db-icon-ds-close delete-coupon"></i>

                </div>
              </div>
              <p *ngIf="coupon?.couponCode && coupon?.couponCode !== '1wf'" class="promo-code">
                <span>{{ coupon?.couponCode }}</span>
                <span class="icons-wrap">
                                                            <i (click)="deleteCoupon(!couponCodeInput?.invalid)"
                                                               class="db-icon db-icon-ds-close-sharp"
                                                               *ngIf="!couponLoading"></i>
                              <db-loading-circular-spinner *ngIf="couponLoading" color="dark"
                                                           class="mr9"></db-loading-circular-spinner>
                              </span>

              </p>
            </div>
            <div class="one-month-free-plans__payment-due-container mb30"
                 [ngClass]="{'has-new-price': !couponLoading}">
              <div [ngClass]="{fadein: !couponLoading}" class="due-today-demo">
                <p>
                  {{(coupon?.freeDaysBeforePayment ? 'text_dueToday' : 'text_payNow') | dbText}}<span
                  [innerHTML]="(mode === 'ssh' || !coupon?.freeDaysBeforePayment) ? ''
                  : ' (' + (coupon?.freeDaysBeforePayment == 30 ? '1 month' : coupon?.freeDaysBeforePayment + ' days' ) + '  free)'"></span>
                </p>
                <b>${{ coupon?.freeDaysBeforePayment ? '0' : newPrice > 0 ? newPrice : chosenPlan?.price }}</b>
              </div>
              @if (newPrice > 0) {
                <span
                  [ngClass]="{fadein: !couponLoading}"
                  class="a db-one-month-free-checkout-demo__then-pay">
               The {{ couponPercent }}% discount will be applied to your first payment,
        followed by standard {{chosenPlan?.periodNumber === 1 ? 'monthly' : 'annual'}} payments after that.
                </span>
              }

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center buttons-wrap">
      <button (click)="changeSubscrId();
      paymentInfo.checkoutHandler(coupon, true)" [ngClass]="{'ds-btn-disabled': loading}" class="ds-btn-black ds-btn-max">
        <span
          *ngIf="!loading">
          @if (coupon?.freeDaysBeforePayment) {
            {{'text_try10WebForFree' | dbText }} {{ couponDays == 30 ? '1 Month' : couponDays + ' Days' }}
          } @else {
              {{ 'text_secureCheckout' | dbText }}
          }
          </span>
        <db-loading-circular-spinner *ngIf="loading" [color]="'white'"></db-loading-circular-spinner>
      </button>
      <p class="db-money-back mt8">
          {{ 'text_upgradePlanStarterCancelAnytime' | dbText}}
      </p>
    </div>
  </div>
  <div class="db-testing-reviews">
    <db-carousel [template]="reviewCarouselRef" [withProgressBar]="true"
                 [items]="reviewers" [navAdditionalClass]="'ml48'"
                 [height]="350" [leftAlign]="true"></db-carousel>
    <div class="db-footer">
      <p><span class="doted">1.5M+</span> websites created<br/> with 10Web AI.</p>
      <db-trustpilot [version]="'micro-combo'" [isDark]="false"></db-trustpilot>
    </div>
  </div>
</div>

<ng-template #reviewCarouselRef let-item='item'>
  <div class="db-review">
    <img src="assets/images/cancel-1wf/quote-dark.svg"/>
    <p class="db-review-text"  [innerHTML]="item.desc"></p>
    <div class="db-user"><p>{{item.title}}</p> <span>10Web user</span></div>
  </div>
</ng-template>

